(function () {
  'use strict';

  function normalized(text) {
    return (text || '').toLocaleLowerCase('ro-RO');
  }

  function isRiflajPerPiece(title) {
    var value = normalized(title);
    return value.indexOf('riflaj') !== -1 && value.indexOf('exterior') === -1;
  }

  function isExteriorRiflaj(title) {
    var value = normalized(title);
    return value.indexOf('riflaj') !== -1 && value.indexOf('exterior') !== -1;
  }

  function addExteriorPriceNote(target, compact) {
    if (!target || target.parentNode.querySelector('.duron-exterior-price-note')) return;
    var note = document.createElement('div');
    note.className = 'duron-exterior-price-note' + (compact ? ' duron-exterior-price-note--card' : '');
    note.innerHTML = '<strong>40 lei</strong> / metru liniar <span aria-hidden="true">&middot;</span> <strong>116 lei</strong> / bucată';
    target.insertAdjacentElement('afterend', note);
  }

  function addUnit(priceElement) {
    if (!priceElement || priceElement.querySelector('.duron-unit-suffix')) return;
    var unit = document.createElement('span');
    unit.className = 'duron-unit-suffix';
    unit.textContent = '/ bucată';
    priceElement.appendChild(unit);
  }

  function enhanceCards(root) {
    var cards = (root || document).querySelectorAll('.products');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute('data-duron-labels') === 'true') return;
      var title = card.querySelector('.grid-link__title');
      if (title && isRiflajPerPiece(title.textContent)) {
        addUnit(card.querySelector('.grid-link__org_price'));
      }
      if (title && isExteriorRiflaj(title.textContent)) {
        addExteriorPriceNote(card.querySelector('.grid-link__org_price'), true);
      }
      card.setAttribute('data-duron-labels', 'true');
    });
  }

  function makeChip(text) {
    var chip = document.createElement('span');
    chip.textContent = text;
    return chip;
  }

  function enhanceProduct() {
    var heading = document.querySelector('.product-single__title');
    if (!heading) return;
    var title = normalized(heading.textContent);
    var acoustic = title.indexOf('riflaj') !== -1 && title.indexOf('acustic') !== -1;
    var flooring = title.indexOf('parchet') !== -1;
    var available = !!document.querySelector('#AddToCart:not([disabled])');

    if (isRiflajPerPiece(title)) {
      addUnit(document.querySelector('.product_single_price .grid-link__org_price'));
    }

    if (isExteriorRiflaj(title)) {
      addExteriorPriceNote(document.querySelector('.product_single_price'), false);
    }

    var priceBlock = document.querySelector('.product_single_price');
    if (priceBlock && !document.querySelector('.duron-feature-chips') && (acoustic || (flooring && available))) {
      var chips = document.createElement('div');
      chips.className = 'duron-feature-chips';
      if (acoustic) {
        chips.appendChild(makeChip('MDF furniruit natural'));
        chips.appendChild(makeChip('Furnir pe 3 laturi'));
      }
      if (flooring && available) chips.appendChild(makeChip('Clasa de trafic 33'));
      priceBlock.insertAdjacentElement('afterend', chips);
    }

    var description = document.querySelector('#desc_pro');
    if (!description || description.querySelector('.duron-material-highlight')) return;
    var highlight = document.createElement('aside');
    highlight.className = 'duron-material-highlight';
    if (acoustic) {
      highlight.innerHTML = '<p class="duron-highlight-eyebrow">Detaliul care face diferența</p>' +
        '<h3>Aspect autentic de lemn natural</h3>' +
        '<p>Riflajul acustic DurON este realizat din <strong>MDF furniruit, nu melaminat</strong>, pentru o textură naturală și un finisaj rafinat.</p>' +
        '<p>Furnirul îmbracă <strong>toate cele trei laturi vizibile</strong> — partea frontală și ambele laterale. Lamelele își păstrează astfel aspectul elegant din orice unghi, fără muchii laterale nefinisate.</p>';
    } else if (flooring && available) {
      highlight.innerHTML = '<p class="duron-highlight-eyebrow">Rezistență pentru spații intens utilizate</p>' +
        '<h3>Clasa de trafic 33</h3>' +
        '<p>Potrivit pentru utilizare rezidențială intensă și pentru spații comerciale cu trafic ridicat, oferind rezistență și stabilitate în utilizarea de zi cu zi.</p>';
    }
    if (highlight.innerHTML) description.insertBefore(highlight, description.firstChild);
  }

  function run() {
    enhanceCards(document);
    enhanceProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var observer = new MutationObserver(function () { enhanceCards(document); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}());
